export const ORDER_CREATE = "ORDER_CREATE";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";

export const CUSTOMER_ORDER_LIST = "CUSTOMER_ORDER_LIST";
export const CUSTOMER_ORDER_LIST_SUCCESS = "CUSTOMER_ORDER_LIST_SUCCESS";
export const CUSTOMER_ORDER_LIST_FAIL = "CUSTOMER_ORDER_LIST_FAIL";

export const CUSTOMER_ORDER_DETAIL = "CUSTOMER_ORDER_DETAIL";
export const CUSTOMER_ORDER_DETAIL_SUCCESS = "CUSTOMER_ORDER_DETAIL_SUCCESS";
export const CUSTOMER_ORDER_DETAIL_FAIL = "CUSTOMER_ORDER_DETAIL_FAIL";

export const CUSTOMER_ORDER_UPDATE = "CUSTOMER_ORDER_UPDATE";
export const CUSTOMER_ORDER_UPDATE_SUCCESS = "CUSTOMER_ORDER_UPDATE_SUCCESS";
export const CUSTOMER_ORDER_UPDATE_FAIL = "CUSTOMER_ORDER_UPDATE_FAIL";

export const PERSONAL_SHOPPER_LIST = "PERSONAL_SHOPPER_LIST";
export const PERSONAL_SHOPPER_LIST_SUCCESS = "PERSONAL_SHOPPER_LIST_SUCCESS";
export const PERSONAL_SHOPPER_LIST_FAIL = "PERSONAL_SHOPPER_LIST_FAIL";

export const PERSONAL_SHOPPER_ASSIGN = "PERSONAL_SHOPPER_ASSIGN";
export const PERSONAL_SHOPPER_ASSIGN_SUCCESS = "PERSONAL_SHOPPER_ASSIGN_SUCCESS";
export const PERSONAL_SHOPPER_ASSIGN_FAIL = "PERSONAL_SHOPPER_ASSIGN_FAIL";

export const CREATE_PAYMENT_ORDER = "CREATE_PAYMENT_ORDER";
export const CREATE_PAYMENT_ORDER_SUCCESS = "CREATE_PAYMENT_ORDER_SUCCESS";
export const CREATE_PAYMENT_ORDER_FAIL = "CREATE_PAYMENT_ORDER_FAIL";

export const VERIFY_PAYMENT = "VERIFY_PAYMENT";
export const VERIFY_PAYMENT_SUCCESS = "VERIFY_PAYMENT_SUCCESS";
export const VERIFY_PAYMENT_FAIL = "VERIFY_PAYMENT_FAIL";

export const GET_PAYMENTS = "GET_PAYMENTS";
export const GET_PAYMENTS_SUCCESS = "GET_PAYMENTS_SUCCESS";
export const GET_PAYMENTS_FAIL = "GET_PAYMENTS_FAIL";

export const RETRY_PAYMENT = "RETRY_PAYMENT";
export const RETRY_PAYMENT_SUCCESS = "RETRY_PAYMENT_SUCCESS";
export const RETRY_PAYMENT_FAIL = "RETRY_PAYMENT_FAIL";

